import React, { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset'
    }
  }
});

function Row(row) {
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();
  const sumProvas = row.row.total_previsto;
  const sumParticipacao = row.row.total_participacao;
  const sumIpea = row.row.total_ipea;
  const host = window.location.host

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell style={{ border: 'none' }}>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" style={{ border: 'none' }}>
          <div style={{ fontWeight: 'bold', fontSize: '18px' }}>
            {row.row.participa_plano_amostral
              ? `(${row.row.ds_dre}) ` +
              `${row.row.nm_escola}` +
              '*' +
              ' ' +
              `- ${row.row.nm_disciplina} - ` +
              row.row.cd_escola
              : `(${row.row.ds_dre}) ` +
              row.row.nm_escola +
              ' ' +
              ` - ${row.row.nm_disciplina} - ` +
              row.row.cd_escola}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: 'none' }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography
                variant="h6"
                gutterBottom
                component="div"
              ></Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 2º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 3º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 4º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 5º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 6º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 7º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 8º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 9º EF</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 1ª EM</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 2ª EM</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}> 3ª EM</div>
                    </TableCell>
                    <TableCell style={{ border: 'none' }}>
                      <div style={{ fontWeight: 'bold' }}>Total</div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={'total_esperado'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Previsto</div>
                    </TableCell>
                    <TableCell>
                      {row.row['2'] ? row.row['2'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['3'] ? row.row['3'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['4'] ? row.row['4'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['5'] ? row.row['5'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['6'] ? row.row['6'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['7'] ? row.row['7'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['8'] ? row.row['8'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['9'] ? row.row['9'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['11'] ? row.row['11'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['12'] ? row.row['12'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['13'] ? row.row['13'].total_provas : '-'}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>{sumProvas}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_participacao'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Efetivo</div>
                    </TableCell>
                    <TableCell>
                      {row.row['2'] ? row.row['2'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['3'] ? row.row['3'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['4'] ? row.row['4'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['5'] ? row.row['5'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['6'] ? row.row['6'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['7'] ? row.row['7'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['8'] ? row.row['8'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['9'] ? row.row['9'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['11'] ? row.row['11'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['12'] ? row.row['12'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['13'] ? row.row['13'].total_participacao : '-'}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {sumParticipacao}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_participacao_pc'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>Total Efetivo %</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['2']
                          ? (row.row['2'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['3']
                          ? (row.row['3'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['4']
                          ? (row.row['4'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['5']
                          ? (row.row['5'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['6']
                          ? (row.row['6'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['7']
                          ? (row.row['7'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['8']
                          ? (row.row['8'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['9']
                          ? (row.row['9'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['11']
                          ? (row.row['11'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['12']
                          ? (row.row['12'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {row.row['13']
                          ? (row.row['13'].total_participacao_pc * 100).toFixed(
                            1
                          ) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {(row.row.total_participacao_pc * 100).toFixed(1) + '%'}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_ipeamt'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>
                        Total Válido ta aq
                      </div>
                    </TableCell>
                    <TableCell>
                      {row.row['2'] ? row.row['2'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['3'] ? row.row['3'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['4'] ? row.row['4'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['5'] ? row.row['5'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['6'] ? row.row['6'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['7'] ? row.row['7'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['8'] ? row.row['8'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['9'] ? row.row['9'].participacao_IPEAMT : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['11']
                        ? row.row['11'].participacao_IPEAMT
                        : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['12']
                        ? row.row['12'].participacao_IPEAMT
                        : '-'}
                    </TableCell>
                    <TableCell align="right">
                      {row.row['13']
                        ? row.row['13'].participacao_IPEAMT
                        : '-'}
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>{sumIpea}</div>
                    </TableCell>
                  </TableRow>
                  <TableRow key={'total_valido_pc'}>
                    <TableCell component="th" scope="row">
                      <div style={{ fontWeight: 'bold' }}>
                        Total Válido esse aq %
                      </div>
                    </TableCell>
                    <TableCell>
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['2']
                          ? (
                            row.row['2'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['3']
                          ? (
                            row.row['3'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['4']
                          ? (
                            row.row['4'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['5']
                          ? (
                            row.row['5'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['6']
                          ? (
                            row.row['6'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['7']
                          ? (
                            row.row['7'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['8']
                          ? (
                            row.row['8'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['9']
                          ? (
                            row.row['9'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['11']
                          ? (
                            row.row['11'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['12']
                          ? (
                            row.row['12'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {' '}
                        {row.row['13']
                          ? (
                            row.row['13'].participacao_IPEAMT_pc * 100
                          ).toFixed(1) + '%'
                          : '-'}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      <div style={{ fontWeight: 'bold' }}>
                        {(row.row.total_ipea_pc * 100).toFixed(1) + '%'}
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const SchoolReportColumn = (data) => {
  const theme = useContext(ThemeContext);

  return (
    <div style={{ width: '97.5%' }}>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            {/* <TableRow> */}
            <div
              style={{
                backgroundColor: theme.primary,
                color: '#ffff',
                height: '50px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: '18px'
              }}
            >
              Escolas
            </div>
            {/* </TableRow> */}
          </TableHead>
          <TableBody>
            {data.data
              ? data.data.map((row) => {
                return (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <Row key={row.nm_escola} row={row} />
                  </div>
                );
              })
              : ''}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default SchoolReportColumn;
